import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgOfficeIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="office_svg__nc-icon-wrapper">
      <path
        data-color="color-2"
        d="M47 7H33V2a1 1 0 1 0-2 0v5H17a1 1 0 0 0-1 1v30h9c1.654 0 3 1.346 3 3v22h8V34c0-1.654 1.346-3 3-3h9V8a1 1 0 0 0-1-1zm-8 17H25a1 1 0 1 1 0-2h14a1 1 0 1 1 0 2zm0-7H25a1 1 0 1 1 0-2h14a1 1 0 1 1 0 2z"
      />
      <path d="M61 33H39a1 1 0 0 0-1 1v28a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V34a1 1 0 0 0-1-1zm-7 23h-8a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2zm0-7h-8a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2zm0-7h-8a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2zM25 40H3a1 1 0 0 0-1 1v21a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V41a1 1 0 0 0-1-1zm-7 16h-8a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2zm0-7h-8a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2z" />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgOfficeStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgOfficeIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const OfficeIcon: any = SvgOfficeStyle;
export default OfficeIcon;
